import {
  QuickFilter, Form, Flexbox,
} from '@/components'
import React from 'react'

function AdoptionsQuickFilter() {
  return (
    <QuickFilter
      initialValues={{
        donorName: '', newTutorName: '', animalName: '',
      }}
      title="Filtrar adoções da feira"
      renderForm={() => (
        <>
          <Flexbox.Column className="col-3 pt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="donorName">Doador</Form.Label>
              <Form.ValidationField
                name="donorName"
                className="input-sm"
                id="donorName"
                autoComplete="none"
                placeholder="Fulano da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 pt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="newTutorName">Novo tutor</Form.Label>
              <Form.ValidationField
                name="newTutorName"
                className="input-sm"
                id="newTutorName"
                autoComplete="none"
                placeholder="Fulano da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
          <Flexbox.Column className="col-3 pt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="animalName">Nome do animal</Form.Label>
              <Form.ValidationField
                name="animalName"
                className="input-sm"
                id="animalName"
                autoComplete="none"
                placeholder="Totó da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
        </>
      )}
    />
  )
}

export default AdoptionsQuickFilter
